import React from 'react';

export const setupWordpressSupport = () => {
    import('@wordpress/blocks').then((wpBlocks) => {
        if (typeof wpBlocks.getCategories === 'function') {
            wpBlocks.getCategories().splice(1, 0, {
                slug: 'two-third',
                title: 'Blocs 2/3',
                icon: <></>,
            });
            wpBlocks.getCategories().splice(1, 0, {
                slug: 'training',
                title: 'Blocs Training',
                icon: <></>,
            });
            wpBlocks.getCategories().splice(1, 0, {
                slug: 'standard',
                title: 'Blocs Standards',
                icon: <></>,
            });
            wpBlocks.getCategories().splice(1, 0, {
                slug: 'product',
                title: 'Blocs Products',
                icon: <></>,
            });
        }
    });
};
